// ============================================================================
// CHANGO V5.0 — Generic public site page (catch-all)
// ============================================================================
// Used by the router for remaining CMS-driven slugs such as /matrix, /cases,
// /help, /blog, and /contact. The URL param becomes the slug.
// ============================================================================

import React from 'react';
import { useParams } from 'react-router-dom';

import PublicSiteShell from './PublicSiteShell.jsx';
import SitePageRenderer from '../../components/SitePageRenderer.jsx';

export default function SitePage({ slug: slugProp }) {
  const params = useParams();
  const slug = slugProp || params.slug;

  return (
    <PublicSiteShell>
      <SitePageRenderer slug={slug} locale="zh-CN" />
    </PublicSiteShell>
  );
}
